export default __webpack_public_path__ + "static/media/purchase.6e01ea2a.svg";